/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import MenuButton from '../components/MenuButton.vue';
import AppLoader from '../components/AppLoader.vue';
import SentinelElement from '../components/SentinelElement.vue';

const mountGlobalComponents = (app) => {
  app.component('AppLoader', AppLoader);
  app.component('MenuButton', MenuButton);
  app.component('FontAwesomeIcon', FontAwesomeIcon);
  app.component('SentinelElement', SentinelElement);
};

export default mountGlobalComponents;
